import { Task } from '@/api';
import { createContext } from 'react';

export interface UnassignedAlertsContextData {
    tasks: Task[];
    loading: boolean;
}

export const UnassignedAlertsContext = createContext<
    UnassignedAlertsContextData | undefined
>(undefined);
